import { marked } from 'marked';

marked.setOptions({ gfm: true, breaks: false });

export type GuideFrontmatter = {
  title: string;
  description: string;
  updated: string;
  slug: string;
};

export function parseFrontmatter(raw: string): {
  meta: GuideFrontmatter;
  body: string;
} {
  const match = raw.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n([\s\S]*)$/);
  if (!match) {
    throw new Error('Guide markdown missing frontmatter');
  }
  const meta: Record<string, string> = {};
  for (const line of match[1].split(/\r?\n/)) {
    const idx = line.indexOf(':');
    if (idx < 0) continue;
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1).trim().replace(/^["']|["']$/g, '');
    meta[key] = value;
  }
  const required = ['title', 'description', 'updated', 'slug'] as const;
  for (const key of required) {
    if (!meta[key]) throw new Error(`Guide missing frontmatter field: ${key}`);
  }
  return {
    meta: {
      title: meta.title,
      description: meta.description,
      updated: meta.updated,
      slug: meta.slug,
    },
    body: match[2].trim(),
  };
}

export function renderMarkdown(markdown: string): string {
  return marked.parse(markdown, { async: false }) as string;
}
